import axiosInstance from "../utils/axios";
import { URL } from "../utils/axios";
const API_URL = `${URL}/api`;

export const fetchBoardMember = async () =>{
    try {
        const response = await axiosInstance.get(`${API_URL}/board-members`)
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const fetchTeamMember = async () =>{
    try {
        const response = await axiosInstance.get(`/api/team`)
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateBoardMember = async ({id, boardMemberData}) =>{
    try {
        const formData = new FormData()
        formData.append("fullName", boardMemberData.fullName);
        formData.append("email", boardMemberData.email);
        formData.append("phone", boardMemberData.phone);
        formData.append("bio", boardMemberData.bio);
        formData.append("company", boardMemberData.company);
        if (boardMemberData.image) {
            formData.append("image", boardMemberData.image);
        }
        const response = await axiosInstance.put(`${API_URL}/board-members/${id}`,formData );
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const createBoardMember = async ({boardMemberData}) =>{
    try {
        const formData = new FormData()
        formData.append("fullName", boardMemberData.fullName);
        formData.append("email", boardMemberData.email);
        formData.append("phone", boardMemberData.phone);
        formData.append("bio", boardMemberData.bio);
        formData.append("company", boardMemberData.company);
        if (boardMemberData.image) {
            formData.append("image", boardMemberData.image);
        }
        const response = await axiosInstance.post(`${API_URL}/board-members`,formData );
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const createTeamMember = async (formData) =>{
    try {
        const response = await axiosInstance.post(`/api/team`,formData );
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateTeamMember = async ({id, formData}) =>{
    try {
        const response = await axiosInstance.put(`/api/team/${id}`,formData );
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteTeamMember = async (id)=>{
    try {
        const response = await axiosInstance.delete(`/api/team/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteBoardMember = async (id)=>{
    try {
        const response = await axiosInstance.delete(`${API_URL}/board-members/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}